import CoreBase from '../../services/engines/CoreBase';
import gatewayService from '../../services/GatewayService';
import responseHelper from '../../services/ResponseHelper';

const _name = 'PrioUpdater';

/**
 * PrioUpdater — single responsibility: knows what goes into a postPrioUpdate call.
 * Caller provides entry + optional gid. Everything else is handled here.
 */
class PrioUpdater extends CoreBase {
    _name = _name;

    /**
     * Posts a prio update for the given entry.
     * @param {object} entry - full entry object
     * @param {string|null} gid - active group id, null if not in YourNotes context
     */
    save = async (entry, gid = null) => {
        try {
            const data = {
                rk: entry.rk,
                title: entry.title,

                service: entry.service,

                stage: entry.stage,
                format: entry.format,
                type: entry.type,
                stateId: entry.stateId,

                cat: entry.cat,
                importanceId: entry.importanceId,
                prioId: entry.prioId,
                viewMode: entry.viewMode ?? null,
                isPinned: entry.isPinned,

                remark: entry.remark,

                gid,
            };
            const resp = await gatewayService.postPrioUpdate(data);
            if (responseHelper.check(resp, '', `${_name}.save`) < 0) {
                this.logError('save', 'post failed');
            }
        } catch (error) {
            this.logError('save', error.message);
        }
    };
}

const prioUpdater = new PrioUpdater();
export default prioUpdater;
